import React, { useEffect, useState } from "react";
import MissingIcon from "../../asset/images/Freeze//missingIcon.svg";
import ModalCommon from "../ModalCommon";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  AESEncryption,
  ApiResDecrypt,
  inputPanVal,
  mobileVal,
} from "../../CommonMethhods/CommonMethods";
import axios from "axios";
import { Freeze_Unfreeze } from "../../Configuration/API_URL";
import { toast } from "react-toastify";

function ValidateUser(prop) {
  let {
    setModalState,
    modalData,
    setPageStatus,
    setSkipData,
    setData,
    setFreezStatus,
  } = prop;
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [validateButtonDisable, setValideButtonDisable] = useState(true);

  const panMobileSchema = Yup.object().shape({
    panNumber: Yup.string()
      .required("*PAN Number is a required field.")
      .matches(
        /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
        "*Please enter 10 Character valid PAN"
      ),
    mobileNoValid: Yup.string()
      .required("*Please Enter Mobile Number")
      .matches(/^[6-9]{1}[0-9]{9}$/, "Mobile Number should be 10 digits"),
  });
  const {
    register: PanMobileRegister,
    handleSubmit: PanMobileHandleSubmit,
    formState: { errors: panMobileError },
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(panMobileSchema),
  });

  const OTPSchema = Yup.object().shape({
    otpVal: Yup.string().required("*Please enter OTP"),
  });
  const {
    register: OTPRegister,
    handleSubmit: OTPHandleSubmit,
    formState: { errors: OTPError },
    setValue: setOTPValue,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(OTPSchema),
  });

  const sendOTPApi = async (data) => {
    let credentialPayload = {
      mobile: data.mobileNoValid,
      pan: data.panNumber,
    };
    let encPayload = AESEncryption(credentialPayload);
    try {
      const responseData = await axios.post(
        Freeze_Unfreeze.sendOtp_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(responseData?.data);
      if (res?.status === 0) {
        // setData({mobile:data.mobileNoValid,pan:data.panNumber})
        localStorage.setItem("mobile", data.mobileNoValid);
        localStorage.setItem("pan", data.panNumber);
        setTimer(30);
        setCanResend(false);
        setValideButtonDisable(false);
        toast.success(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      clearInterval(interval);
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const validateOTPApi = async (data) => {
    let credentialPayload = {
      mobile: getValues("mobileNoValid"),
      pan: getValues("panNumber"),
      otp: data.otpVal,
    };
    let encPayload = AESEncryption(credentialPayload);
    try {
      const responseData = await axios.post(
        Freeze_Unfreeze.validateOtp_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(responseData?.data);
      setFreezStatus(res.data.freeze);
      if (res?.status === 0) {
        localStorage.setItem("freeze", res.data.freeze);

        toast.success(res?.data);
        setPageStatus("fnuPage");
      } else {
        if (
          res?.message ==
            "Your request for freeze is already in process. Please try again later" ||
          res?.message ==
            "Your request for unfreeze is already in process. Please try again later"
        ) {
          let dataObject = modalData.alreadyProcess;
          dataObject.text = res?.message;
          setModalState({ modal: true, data: dataObject });
        } else if (
          res?.message ===
          "Kindly wait for 30 minutes before placing unfreeze request"
        ) {
          let dataObject = modalData.alreadyProcess;
          dataObject.text = res?.message;
          setModalState({ modal: true, data: dataObject });
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      toast.error(error?.message);

      console.log(error);
    } finally {
      setOTPValue("otpVal", "");
    }
  };

  const OnSendOTP = (data) => {
    sendOTPApi(data);
  };

  const onFinalSubmit = (data) => {
    validateOTPApi(data);
  };
  const OnSkip = async (data) => {
    let credentialPayload = {
      mobile: data.mobileNoValid,
      pan: data.panNumber,
    };
    let encPayload = AESEncryption(credentialPayload);
    try {
      const responseData = await axios.post(
        Freeze_Unfreeze.SkipAuthentication,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(responseData?.data);
      if (res?.status === 0) {
        localStorage.setItem("mobile", data.mobileNoValid);
        localStorage.setItem("pan", data.panNumber);
        if (res.data.QueAnsList) {
          setSkipData(res.data.QueAnsList);
          setPageStatus("verficationQNA");
        } else {
          return;
        }
      } else {
        if (res?.message === "Mobile or PAN not matched") {
          toast.error(res?.message);
        } else {
          let dataObject = modalData.alreadyProcess;
          dataObject.text = res?.message;
          setModalState({ modal: true, data: dataObject });
        }
      }
    } catch (error) {
      toast.error(error?.message);

      console.log(error);
      toast.error(error?.message);
    }
  };
  return (
    <div className="card-box validateUserWrapper">
      <div className="card-title">
        <h2 className="h2-css-all">Validate User</h2>
      </div>
      <div className="card-contnent">
        <div className="row">
          <div className="col-md-8">
            <form onSubmit={PanMobileHandleSubmit(OnSendOTP)}>
              <div className="row">
                <div className="col-md-6 col-sm-3 col-12">
                  <div className="form-group">
                    <label className="form-label">PAN Number :</label>
                    <div
                      className={`rm-custom-dropdown ${
                        panMobileError?.panNumber?.message
                          ? "border border-danger"
                          : ""
                      }`}
                    >
                      <input
                        type="text"
                        name="search-text"
                        maxLength={11}
                        className="input-st ap"
                        {...PanMobileRegister("panNumber")}
                        onInput={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                          inputPanVal(e);
                        }}
                        // defaultValue={"FBHPP0398R"}
                        placeholder="PAN Number"
                        autoComplete="off"
                      />
                    </div>
                    <span className="forget-link text-align-start">
                      {panMobileError?.panNumber?.message}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 col-sm-4 col-12 ">
                  <div className="form-group ml-5">
                    <label className="form-label">Mobile Number :</label>
                    <div
                      className={`rm-custom-dropdown ${
                        panMobileError?.mobileNoValid?.message
                          ? "border border-danger"
                          : ""
                      }`}
                    >
                      <input
                        type="text"
                        name="search-text"
                        maxLength={10}
                        className="input-st"
                        placeholder="Mobile Number"
                        {...PanMobileRegister("mobileNoValid")}
                        onKeyPress={(e) => mobileVal(e)}
                        // defaultValue={"9028081010"}
                        autoComplete="off"
                      />
                    </div>
                    <div className="bottom-phone-part">
                      <span className="forget-link">
                        {panMobileError?.mobileNoValid?.message}
                      </span>
                      {canResend ? (
                        <button type="submit" className="send-otp-btn">
                          Send OTP
                        </button>
                      ) : (
                        <p>
                          <span className="send-otp-btn resend-otp">
                            Resend OTP in 00:{timer}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-4">
            <form onSubmit={OTPHandleSubmit(onFinalSubmit)}>
              <div className="row">
                <div className="col-md-12 col-sm-4 col-12">
                  <div className="form-group ">
                    <label className="form-label">Enter OTP :</label>
                    <div
                      className={`rm-custom-dropdown ${
                        OTPError?.otpVal?.message ? "border border-danger" : ""
                      }`}
                    >
                      <input
                        type="text"
                        name="search-text"
                        maxLength={4}
                        className="input-st"
                        placeholder="Enter OTP"
                        autoComplete="off"
                        {...OTPRegister("otpVal")}
                      />
                    </div>
                    <span className="forget-link text-align-start">
                      {OTPError?.otpVal?.message}
                    </span>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="right-side-button">
                    <button
                      type="submit"
                      className="validate-btn"
                      disabled={validateButtonDisable}
                    >
                      Validate
                    </button>
                    <button
                      type="button"
                      className="skip-btn"
                      onClick={PanMobileHandleSubmit(OnSkip)}
                    >
                      Skip OTP Authentication
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* <div className="validate-skip-btn">
          <div className="unregister-mobile-popUp">
            <div className="d-flex">
              <img src={MissingIcon} alt="missing-icon" />
              <h4>Unregistered Mobile Number </h4>
            </div>
            <h6>
              Mobile number is not registered with Bajaj Broking. Click on Skip
              OTP Authentication to proceed
            </h6>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ValidateUser;
